import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import EssentialsHero from "./hero-section";
import "../../assets/css/--page-store-items.css";
import BrowseCategorySection from "./BrowseCategorySection";
import FeaturedVendors from "./FeaturedVendors";
import SnacksBannerSection from "./SnacksBannerSection";
import PopularCategories from "./PopularCategories";
import VisitStoreBanner from "./VisitStoreBanner";
import CustomerReviews from "./CustomerReviews";
import ScrollToTop from "../../components/ScrollToTop";

export default function StoreItemPage() {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) return;
    const element = document.getElementById(location.hash.slice(1));
    element?.scrollIntoView({ behavior: "smooth", block: "start" });
  }, [location.hash]);

  return (
    <>
    <EssentialsHero/>
    <BrowseCategorySection/>
    <FeaturedVendors/>
    <SnacksBannerSection/>
    <PopularCategories/>
    <VisitStoreBanner/>
    <CustomerReviews/>
    <ScrollToTop />
    </>
  );
}